import * as React from "react";

import { EnquiryContext } from "./context/EnquiryState";

export const PromoThankYouBanner = () => {

	const {
		state,
	} = React.useContext(EnquiryContext)

	return (
		<React.Fragment>
			<div className="rounded-xl grid grid-cols-1 md:grid-cols-3 overflow-hidden mt-6">
				
				<div className="aspect-w-16 aspect-h-7 md:aspect-h-11 lg:aspect-h-14 xl:aspect-h-9 2xl:aspect-h-7">
					<img className="h-full object-cover object-[60%_50%] xl:object-right-bottom" src="/img/enquiry/promo-mama-enquiry-thank-you.png" alt="lady baby" />
				</div>
				
				<div className="md:col-span-2 text-skin-heading px-8 py-6 flex flex-row items-center" style={{ backgroundColor: '#82A8E7'}}>
					<div>
						<div className="text-skin-heading font-bold text-xl mb-5 leading-tight">Thanks for entering! We're crossing our fingers for you... plus you can always enquire at another centre for another chance to win!</div>
						<a href="/pdfs/freechildcare/care-for-kids-12-month-free-childcare-competition.pdf" target="_blank" className="text-xs underline">(T&Cs apply)</a>
					</div>
				</div>
			</div>

			{/*OLD BANNER*/}
			{/*<div className="rounded-xl grid grid-cols-1 md:grid-cols-3 overflow-hidden mt-6">*/}
			{/*	<div className="bg-skin-eggplant">*/}
			{/*		<div className="aspect-w-16 aspect-h-7 sm:aspect-h-5 md:aspect-h-11 lg:aspect-h-14 xl:aspect-h-9 2xl:aspect-h-7">*/}
			{/*			<img className="h-full object-cover" src="/img/enquiry/promo-hand-up-enquiry-thank.png" alt="hands up" />*/}
			{/*		</div>*/}
			{/*	</div>*/}
			{/*	<div className="md:col-span-2 bg-skin-bubblegum text-skin-heading px-8 py-6 flex flex-row items-center">*/}
			{/*		<div>*/}
			{/*			<div className="font-bold text-xl mb-5 leading-tight">Thanks for entering! We're crossing our fingers for you... plus you can always enquire at another centre for another chance to win!</div>*/}
			{/*			<a href="/child-care-articles/article/1087" target="_blank" className="text-xs underline">(T&Cs apply)</a>*/}
			{/*		</div>*/}
			{/*	</div>*/}
			{/*</div>*/}

		</React.Fragment>
	);
}